import { initialModules, initialState } from './initialState';
import { MymeEditorAction, MymeEditorContext } from './types';

export const reducer = (state: MymeEditorContext, action: MymeEditorAction): MymeEditorContext => {
  switch (action.type) {
    case 'SWITCH_STEP': {
      return {
        ...state,
        step: action.payload.step
      };
    }
    case 'SET_REDIRECT': {
      return {
        ...state,
        redirect: action.payload
      };
    }
    case 'CLEAR_REDIRECT': {
      return {
        ...state,
        redirect: ''
      };
    }
    case 'SET_INITIAL_INTEREST_DATA': {
      return {
        ...state,
        myme: action.payload
      };
    }
    case 'CREATE_INTREST': {
      const { id, name, type } = action.payload;
      return {
        ...state,
        myme: {
          ...state.myme,
          id,
          name,
          type,
          modules: initialModules
        },
        isCreator: true
      };
    }
    case 'UPDATE_INTREST_DETAILS': {
      const { name, type, ...rest } = action.payload; // name, type optional

      return {
        ...state,
        myme: {
          ...state.myme,
          ...rest,
          name: name || state.myme.name,
          type: type || state.myme.type
        },
        shouldBeDeletedOnUmount: false
      };
    }
    case 'UPLOAD_PREVIEW_IMAGE': {
      const { previewImageFilePath } = action.payload;

      return {
        ...state,
        myme: {
          ...state.myme,
          previewImageFilePath
        }
      };
    }
    case 'SET_MODULES': {
      const modules = action.payload;

      return {
        ...state,
        myme: {
          ...state.myme,
          modules
        },
        shouldBeDeletedOnUmount: false
      };
    }
    case 'DELETE_ON_UNMOUNT': {
      return {
        ...state,
        shouldBeDeletedOnUmount: true
      };
    }
    case 'RESET_INTREST_EDITOR': {
      return {
        ...initialState
      };
    }
    default: {
      return { ...state };
    }
  }
};
